module.exports = {
  message: {
    "Account": 'Account management',
    "Home page management": "Home page management",
    "Online magazine management": "Magazine management",
    "Issue management": "Issue management",
    "Article management": "Article management",
    "Sub-category management": "Sub-category management",
    "User Listing": "User Listing",
    "Role listing": "Role Listing",
    "userName": "Username",
    "Status": "Status",
    "Search": "Search",
    "datagridresult": " results in total",
    "RoleName": "Role Name",
    "createdTime": "Created date",
    "Add": "Add",
    "Delete": "Delete",
    "password": "Password",
    "Tel": "Telephone",
    "email": "Email",
    "Role": "Role",
    "Active": "Active",
    "Inactive": "Inactive",
    "Save": "Save",
    "Cancel": "Cancel",
    "Confirm": "Confirm",
    "Warning": "Warning",
    "RoleType": "Role type",
    "Super Admin": "Super Admin",
    "Platform": "Platform",
    "FunctionSelection": "Function & Feature",
    "subCategoryName": "Sub-category name",
    "Category": "Category",
    "subCategory": "Sub-category",
    "All": "--- All ---",
    "selectDefault": "--- Default ---",
    "PleaseSelect": "--- Please Select ---",
    "title": "Title",
    "issueNumber": "Issue number",
    "Job function": "Related job function",
    "occupation": "Related occupation",
    "LogOut": "Logout",
    "Issue": "Issue",
    "Resource library management": "Resource library management",
    "Resource category management": "Resource category management",
    "Link management": "Link management",
    "name": "name",
    "English": "English",
    "Simplified Chinese": "Simplified Chinese",
    "Traditional Chinese": "Traditional Chinese",
    "issueName": "Issue name",
    "HomePage": "Home page",
    "userDetail": "User details",
    "roleDetail": "Role details",
    "articleList": "Article list",
    "articleDetail": "Article details",
    "subCategoryList": "Sub-category list",
    "subCategoryDetail": "Sub-category details",
    "issueList": "Issue list",
    "issueDetail": "Issue details",
    "resourceList": "resourceList",
    "resourceDetail": "resourceDetail",
    "resourceCategoryList": "resourceCategoryList",
    "resourceCategoryDetail": "resourceCategoryDetail",
    "Course management": "Course management",
    "courseImport": "Course Import",
    "Area Of Study management": "Area Of Study management",
    "areaOfStudyImport": "areaOfStudyImport",
    "Add Banner": "Add banner",
    "Add hot picks": "Add hot picks",
    "Save as draft": "Save as draft",
    "Publish": "Publish",
    "Draft": "Draft",
    "Published": "Published",
    "Banner": "Banner (Minimum: 1; Maximum: 5)",
    "Article title:": "Article title:",
    "Hot picks": "Hot picks (Must be 3)",
    "Ready to Publish": "Ready to Publish",
    "Article title": "Article title",
    "Preview": "Preview",
    "Edit": "Edit",
    "Author/Interviewee name": "Author/Interviewee name",
    "Author/Interviewee title": "Author/Interviewee title",
    "Author/Interviewee icon": "Author/Interviewee icon",
    "Short description": "Short description",
    "Facebook article ID": "Facebook article ID",
    "Cover image": "Cover image",
    "Cover image alt text": "Cover image alt text",
    "Content editor": "Content editor",
    "Slideshow": "Slideshow",
    "Tags": "Tags",
    "tagsTip": 'Add symbol ";" as separator between tags',
    "Add tag": "Add tag",
    "Recommended articles": "Recommended articles",
    "Maximum 5": "Maximum 5",
    "Image size error": "Image size error!",
    "Dimension Error": "Dimension Error!",
    "deleteContent": "Are you sure to delete the selected content?",
    "Are you sure to publish": "Are you sure to publish?",
    "Are you sure to readyToPublish": "Are you sure to readyToPublish",
    "Are you sure to edit": "Are you sure to edit?",
    "Must be 3": "一定要3個",
    "MinimumMaximum": "最少1個，最多10個",
    "Minimum 5 occupation": "最少5個職業",
    "floatingBanner": "Floating Banner",
    "Floating banner management": "Floating banner management",
    "floatingBannerList": "Floating-banner list",
    "bannerImage": "Image",
    "bannerName": "Floating banner name",
    "bannerContent": "Banner Content",
    "buttonUrl": "Button Url",
    "floatingBannerDetail": "Floating-banner details",
    "Add floating banner": "Add floating banner",
    "FloatingBanner name:": "FloatingBanner name:",
    "FloatingBanner name": "FloatingBanner name",
    "FloatingBannerNum": "Floating Banner (Minimum: 1; Maximum: 5)",
    "updatedTime": "Last updated date",
    "Department banner management": "Department banner management",
    "departmentBanner": "Department Banner",
    "departmentBannerList": "Department-banner list",
    "Add department banner": "Add department banner",
    "DepartmentBanner name:": "DepartmentBanner name:",
    "DepartmentBanner name": "Department banner name",
    "departmentBannerDetail": "Department-banner details",
    "DepartmentBannerNum": "Department Banner (Minimum: 1)",
    "Banner management": "Banner management",
    "Top banner management": "Top banner management",
    "topBannerList": "Top-banner list",
    "topBannerDetail": "Top-banner details",
    "TopBanner name": "Top banner name",
    "TopBanner name:": "TopBanner name:",
    "Name": "Name",
    "shortDescription": "Short description",
    "url": "URL",
    "TopBannerNum": "Top Banner (Minimum: 1; Maximum: 20)",
    "Add top banner": "Add top banner",
    "topBanner": "Top banner",
    "Career magazine": "Career magazine",
    "Career magazineNum": "Career magazine (Must be 3)",
    "Add magazine": "Add magazine",
    "floating bannerContent": "Floating banner content",
    "Job import management": "Job import management",
    "jobImportList": "Job import list",
    "JobSource name": "Job source name",
    "jobImportDetail": "Job import detail",
    "Period": "Period",
    "Import": "Import",
    "active": "Active",
    "inactive": "Inactive",
    "Pending": "Pending",
    "Expired": "Expired",
    "To": "To",
    "startTime": "Start Time",
    "endTime": "End Time",
    "upload": "Upload",
    "download": "Download template",
    "lastFile": "Last uploaded file",
    "last update time": "Last update time",
    "Instant Filter": "Instant Filter On/Off",
    "On": "On",
    "Off": "Off",
    "Instant filter status": "Instant filter status",
    "Occupation management": "Occupation management",
    "Resource management": "Resource management",
    "Info Centre management": "Info Centre management",
    "Quiz management": "Quiz management",
    "Quiz Popup": "Quiz Popup",
    "Import QR course": "Import QR course",
    "Import CEF course": "Import CEF course",
    "Import VTC CIP": "Import VTC-CIP / QR-CIP",
    "Import Area of Study": "Import Area of Study",
    "Import Delivery mode": "Import Delivery mode",
    "Import Level": "Import Level",
    "Upload success": "Upload success",
    "Original Img": "Import Original Image",
    "Crop Img": "Import Crop Image",
    "Select file": "Select file",
    "Import Occupation": "Import Occupation",
    "Import Info Centre": "Import Info Centre",
    "Import Resource": "Import Resource",
    "Import Tag": "Import Tag",
    "System Theme management": "Monochrome Mode",
    "SaveSuccess": "Save Success",
    "StartTimeLessThanEndTime": "Start Time must be less than End Time",


    "Eight centre management": "Eight Centre management",
    "Eight centre list management" : "Listing management",
    "Eight centre detail management" : "Detail management",
    "Centres Name": "Centres Name",
    "Centres Content" : "Centres Content",
    "Add Centres Content" : "Update Content",

    "Sub-title": "Sub-title",
    "Add Factor": "Add Factor",
    "Add Demand": "Add Demand",
    "Add Section": "Add Section",
    "Add Skill": "Add Skill",
    "Add Knowledge": "Add Knowledge",
    "Add New Item" : "Add New Item",

  }
}